import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import * as Api from '../utils/Api'
import * as App from '../utils/App'
import {API_URL, DC_URL} from '../constants/App'
// import cart from './modules/cart'
// import products from './modules/products'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // import some modules...
    // cart,
    // products
  },
  state: {
    businessList: [],
    userList: [],
    editingList: [],
    itemList: [],
    cartData: {},
    orderHistoryList: []
  },
  mutations: {
    SET_BUSINESS (state, businessList) {
      state.businessList = businessList
    },
    SET_USERLIST (state, userList) {
      state.userList = userList
    },
    SET_EDITINGLIST (state, editingList) {
      state.editingList = editingList
    },
    SAVE_PRODUCT_LIST (state, itemList) {
      state.itemList = itemList
    },
    SET_CARTDATA (state, cartData) {
      state.cartData = cartData
    },
    SET_ORDER_HISTORY (state, history) {
      state.orderHistoryList = history
    }
  },
  methods: {
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    }
  },
  actions: {
    loadBusinessList ({ commit, state }, reload = false) {
      axios.get(API_URL.PLANNING + '/business'
      ).then(response => {
        commit('SET_BUSINESS', response.data.data)
      })
    },
    loadUserList ({ commit, state }) {
      axios.get(API_URL.ADMIN + '/list'
      ).then(response => {
        commit('SET_USERLIST', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    loadEditingList ({ commit, state }) {
      axios.get(API_URL.PLANNING + '/editing-list'
      ).then(response => {
        commit('SET_EDITINGLIST', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    loadUserListDc ({ commit, state }) {
      axios.get(DC_URL.USER + '/list'
      ).then(response => {
        commit('SET_USERLIST', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    async loadCartData ({ commit, state }) {
      await axios.get(DC_URL.CART + '/list'
      ).then(response => {
        commit('SET_CARTDATA', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    loadSaveProductList ({commit, state}) {
      axios.get(DC_URL.SAVE + '/read-productlist'
      ).then(response => {
        let saveList = response.data.data.map(d => {
          let product = {
            productId: d.productId,
            businessName: d.businessName,
            seriesName: d.seriesName,
            productName: d.productName,
            saveDate: d.saveDate,
            dcFdId: d.dcFdId,
            fdId: d.fdId,
            categoryId: d.cdcCategoryType,
            dcWidth: d.width,
            dcHeight: d.height,
            dcHeight2: d.height2,
            dcDepth: d.depth,
            dcDepth2: d.depth2,
            dcBSize: d.bsize,
            dcBType: d.btype,
            dcCSize: d.csize,
            dcCType: d.ctype,
            dcDSize: d.dsize,
            dcDType: d.dtype,
            dcColorDoor: d.colorDoor.no,
            dcColorDoorDetail: d.colorDoor.no ? {
              id: d.colorDoor.no,
              name: d.colorDoor.name,
              type: d.colorDoor.type,
              no: d.colorDoor.dispNo,
              img: d.colorDoor.img ? App.getMmstyleResource('color/' + d.colorDoor.img) : '',
              imgB: d.colorDoor.img ? App.getMmstyleResource('color/' + d.colorDoor.img) : ''
            } : {},
            dcColorBox: d.colorCabine.no,
            dcColorBoxDetail: d.colorCabine.no ? {
              id: d.colorCabine.no,
              name: d.colorCabine.name,
              type: d.colorCabine.type,
              no: d.colorCabine.dispNo,
              img: d.colorCabine.img ? App.getMmstyleResource('color/' + d.colorCabine.img) : '',
              imgB: d.colorCabine.img ? App.getMmstyleResource('color/' + d.colorCabine.img) : ''
            } : {},
            dcColorCounter: d.colorCounter.no,
            dcColorCounterDetail: d.colorCounter.no ? {
              id: d.colorCounter.no,
              name: d.colorCounter.name,
              type: d.colorCounter.type,
              no: d.colorCounter.dispNo,
              img: d.colorCounter.img ? App.getMmstyleResource('color/' + d.colorCounter.img) : '',
              imgB: d.colorCounter.img ? App.getMmstyleResource('color/' + d.colorCounter.img) : ''
            } : {},
            dcShelfCount: d.shelfCount,
            dcFillerCount: d.fillerCount,
            dcProductCount: d.productCount,
            dcWorkFlag: d.structFlag,
            dcSaveResrchFlag: d.resrchFlag,
            dcSaveExistDeliFlag: d.existDeliFlag,
            businessId: d.businessId,
            dcSaveDeliPostcd: d.deliPostcd,
            deliAddress: d.deliAddress,
            dcSaveDeliState: '',
            dcSaveDeliCity: '',
            dcSaveDeliStreet: '',
            dcStructSameAddressFlag: d.structSameAddressFlag,
            dcStructPostcd: d.structPostcd,
            dcStructState: '',
            dcStructCity: '',
            dcStructStreet: '',
            dcConstructOpServiceFlag: d.carryInFlag,
            dcSaveExistResrchFlag: d.existResrchFlag,
            dcSaveSameAddressFlag: d.resrchSameAddressFlag,
            dcSaveResrchPostcd: d.resrchPostcd,
            isDisProduct: d.isDisProduct,
            colorStyle: d.colorStyle
          }
          return product
        })

        commit('SAVE_PRODUCT_LIST', saveList)
      }).catch(error => {
        console.error(error)
      })
    },
    loadOrderHistoryList ({commit, state}) {
      axios.get(DC_URL.ORDER + '/history/list'
      ).then(response => {
        commit('SET_ORDER_HISTORY', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main/js/store/index.js